var _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1920,
    viewBox: "0 0 1920 1920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    clipPath: "url(#clip0_1240_114297)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1240_114297",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 576,
    width: 90,
    height: 90
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 621,
    r: 45,
    fill: "#196DB6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1240_114297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.853 533L274.853 623",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.782 540.071L267.782 630.071",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.711 547.142L260.711 637.142",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.64 554.213L253.64 644.213",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.568 561.284L246.568 651.284",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.497 568.355L239.497 658.355",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.427 575.426L232.427 665.426",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.355 582.497L225.355 672.497",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.284 589.569L218.284 679.569",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.213 596.64L211.213 686.64",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.143 603.711L204.143 693.711",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.071 610.782L197.071 700.782",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 617.853L190 707.853",
    stroke: "#196DB6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1240_114297",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 774,
    y: 189,
    width: 562,
    height: 562
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1055,
    cy: 470,
    r: 280,
    fill: "#F54F5E",
    stroke: "#F54F5E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1240_114297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1054.61 -89L1614.61 471",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.54 -81.929L1607.54 478.071",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.47 -74.8579L1600.47 485.142",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.4 -67.7869L1593.4 492.213",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.33 -60.7158L1586.33 499.284",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.26 -53.6448L1579.26 506.355",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.19 -46.5737L1572.19 513.426",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.12 -39.5027L1565.12 520.497",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.046 -32.4316L1558.05 527.568",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.975 -25.3606L1550.97 534.639",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.903 -18.2893L1543.9 541.711",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.833 -11.2183L1536.83 548.782",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.762 -4.14722L1529.76 555.853",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.69 2.92383L1522.69 562.924",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.619 9.99487L1515.62 569.995",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.549 17.0659L1508.55 577.066",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.478 24.137L1501.48 584.137",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.406 31.208L1494.41 591.208",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.335 38.2791L1487.33 598.279",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.264 45.3501L1480.26 605.35",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.193 52.4211L1473.19 612.421",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.122 59.4924L1466.12 619.492",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.051 66.5635L1459.05 626.563",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.979 73.6345L1451.98 633.635",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.909 80.7056L1444.91 640.706",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.838 87.7766L1437.84 647.777",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.767 94.8477L1430.77 654.848",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.695 101.919L1423.7 661.919",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.624 108.99L1416.62 668.99",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.554 116.061L1409.55 676.061",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.482 123.132L1402.48 683.132",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.411 130.203L1395.41 690.203",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.34 137.274L1388.34 697.274",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.27 144.345L1381.27 704.345",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.198 151.416L1374.2 711.416",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.127 158.487L1367.13 718.487",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.056 165.558L1360.06 725.558",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.984 172.629L1352.98 732.629",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.914 179.7L1345.91 739.7",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.843 186.771L1338.84 746.771",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.771 193.843L1331.77 753.843",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.7 200.914L1324.7 760.914",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.63 207.985L1317.63 767.985",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.559 215.056L1310.56 775.056",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.487 222.127L1303.49 782.127",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.416 229.198L1296.42 789.198",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.346 236.269L1289.35 796.269",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.274 243.34L1282.27 803.34",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.203 250.411L1275.2 810.411",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.132 257.482L1268.13 817.482",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.061 264.553L1261.06 824.553",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.99 271.624L1253.99 831.624",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.919 278.695L1246.92 838.695",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.848 285.767L1239.85 845.767",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.776 292.838L1232.78 852.838",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.706 299.909L1225.71 859.909",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.635 306.98L1218.63 866.98",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.563 314.051L1211.56 874.051",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.492 321.122L1204.49 881.122",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.421 328.193L1197.42 888.193",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.351 335.264L1190.35 895.264",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.279 342.335L1183.28 902.335",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.208 349.406L1176.21 909.406",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.137 356.477L1169.14 916.477",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.066 363.548L1162.07 923.548",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.995 370.619L1155 930.619",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.924 377.69L1147.92 937.69",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.853 384.761L1140.85 944.761",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.782 391.833L1133.78 951.833",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.711 398.904L1126.71 958.904",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.64 405.975L1119.64 965.975",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.568 413.046L1112.57 973.046",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.497 420.117L1105.5 980.117",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.427 427.188L1098.43 987.188",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.355 434.259L1091.36 994.259",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.284 441.33L1084.28 1001.33",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.213 448.401L1077.21 1008.4",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.143 455.472L1070.14 1015.47",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.071 462.543L1063.07 1022.54",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 469.614L1056 1029.61",
    stroke: "#F54F5E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1240_114297",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1605,
    y: 59,
    width: 262,
    height: 262
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1736,
    cy: 190,
    r: 130,
    fill: "#26B6E0",
    stroke: "#26B6E0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1240_114297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1733.56 -67L1993.56 193",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1726.49 -59.9289L1986.49 200.071",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.42 -52.8579L1979.42 207.142",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712.35 -45.7868L1972.35 214.213",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.27 -38.7157L1965.27 221.284",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.2 -31.6447L1958.2 228.355",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.13 -24.5736L1951.13 235.426",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.06 -17.5025L1944.06 242.497",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.99 -10.4315L1936.99 249.569",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.92 -3.3604L1929.92 256.64",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.85 3.71068L1922.85 263.711",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.78 10.7817L1915.78 270.782",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648.71 17.8528L1908.71 277.853",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.63 24.9239L1901.63 284.924",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.56 31.9949L1894.56 291.995",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.49 39.066L1887.49 299.066",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.42 46.1371L1880.42 306.137",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.35 53.2082L1873.35 313.208",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606.28 60.2792L1866.28 320.279",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.21 67.3503L1859.21 327.35",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592.14 74.4214L1852.14 334.421",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.07 81.4924L1845.07 341.492",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578 88.5635L1838 348.563",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.92 95.6346L1830.92 355.635",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.85 102.706L1823.85 362.706",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.78 109.777L1816.78 369.777",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.71 116.848L1809.71 376.848",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.64 123.919L1802.64 383.919",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535.57 130.99L1795.57 390.99",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.5 138.061L1788.5 398.061",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.43 145.132L1781.43 405.132",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.36 152.203L1774.36 412.203",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.28 159.274L1767.28 419.274",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500.21 166.345L1760.21 426.345",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493.14 173.416L1753.14 433.416",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.07 180.487L1746.07 440.487",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479 187.558L1739 447.558",
    stroke: "#26B6E0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1240_114297",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -264,
    y: -650,
    width: 1120,
    height: 1120
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: -90,
    r: 560,
    fill: "#196DB6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1240_114297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.305 -1116.08L1322.3 3.92383",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.233 -1109.01L1315.23 10.9946",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.163 -1101.93L1308.16 18.0659",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.092 -1094.86L1301.09 25.1367",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.021 -1087.79L1294.02 32.208",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.949 -1080.72L1286.95 39.2788",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.879 -1073.65L1279.88 46.3501",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.808 -1066.58L1272.81 53.4214",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.736 -1059.51L1265.74 60.4922",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.665 -1052.44L1258.67 67.5635",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.594 -1045.37L1251.59 74.6343",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.523 -1038.29L1244.52 81.7056",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.452 -1031.22L1237.45 88.7764",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.381 -1024.15L1230.38 95.8477",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.31 -1017.08L1223.31 102.918",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2393 -1010.01L1216.24 109.99",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.168 -1002.94L1209.17 117.061",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0967 -995.868L1202.1 124.132",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0254 -988.797L1195.03 131.203",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9541 -981.726L1187.95 138.274",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8838 -974.655L1180.88 145.345",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8125 -967.584L1173.81 152.416",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7412 -960.513L1166.74 159.487",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6699 -953.442L1159.67 166.558",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5996 -946.371L1152.6 173.629",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5283 -939.3L1145.53 180.7",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.457 -932.229L1138.46 187.771",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3857 -925.158L1131.39 194.842",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31445 -918.086L1124.31 201.914",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.75586 -911.015L1117.24 208.985",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.82715 -903.944L1110.17 216.056",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.8984 -896.873L1103.1 223.127",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.9697 -889.802L1096.03 230.198",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.04 -882.731L1088.96 237.269",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.1113 -875.66L1081.89 244.34",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.1826 -868.589L1074.82 251.411",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.2539 -861.518L1067.75 258.482",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59.3242 -854.447L1060.68 265.553",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-66.3955 -847.376L1053.6 272.624",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.4668 -840.305L1046.53 279.695",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.5381 -833.233L1039.46 286.767",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-87.6094 -826.163L1032.39 293.837",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-94.6797 -819.091L1025.32 300.909",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.751 -812.021L1018.25 307.979",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-108.822 -804.949L1011.18 315.051",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-115.894 -797.878L1004.11 322.122",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-122.964 -790.807L997.036 329.193",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-130.035 -783.736L989.965 336.264",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.106 -776.665L982.894 343.335",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.178 -769.594L975.822 350.406",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-151.249 -762.523L968.751 357.477",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-158.319 -755.452L961.681 364.548",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165.391 -748.381L954.609 371.619",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-172.462 -741.31L947.538 378.69",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-179.533 -734.239L940.467 385.761",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.604 -727.167L933.396 392.833",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-193.675 -720.097L926.325 399.903",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-200.746 -713.025L919.254 406.975",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-207.817 -705.955L912.183 414.045",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-214.888 -698.883L905.112 421.117",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221.959 -691.812L898.041 428.188",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229.03 -684.741L890.97 435.259",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-236.102 -677.67L883.898 442.33",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-243.173 -670.599L876.827 449.401",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-250.243 -663.528L869.757 456.472",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-257.314 -656.457L862.686 463.543",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-264.386 -649.386L855.614 470.614",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-271.457 -642.315L848.543 477.685",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-278.527 -635.244L841.473 484.756",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285.599 -628.173L834.401 491.827",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-292.67 -621.102L827.33 498.898",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-299.741 -614.03L820.259 505.97",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-306.812 -606.959L813.188 513.041",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-313.883 -599.888L806.117 520.112",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-320.954 -592.817L799.046 527.183",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-328.025 -585.746L791.975 534.254",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-335.097 -578.675L784.903 541.325",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-342.167 -571.604L777.833 548.396",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349.238 -564.533L770.762 555.467",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-356.31 -557.462L763.69 562.538",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-363.381 -550.391L756.619 569.609",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-370.451 -543.32L749.549 576.68",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-377.522 -536.249L742.478 583.751",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-384.594 -529.178L735.406 590.822",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-391.665 -522.106L728.335 597.894",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-398.736 -515.036L721.264 604.964",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405.807 -507.964L714.193 612.036",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-412.878 -500.894L707.122 619.106",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-419.949 -493.822L700.051 626.178",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-427.021 -486.751L692.979 633.249",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-434.091 -479.68L685.909 640.32",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-441.162 -472.609L678.838 647.391",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-448.233 -465.538L671.767 654.462",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-455.305 -458.467L664.695 661.533",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-462.376 -451.396L657.624 668.604",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469.446 -444.325L650.554 675.675",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-476.518 -437.254L643.482 682.746",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.589 -430.183L636.411 689.817",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-490.66 -423.112L629.34 696.888",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-497.73 -416.041L622.27 703.959",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-504.802 -408.97L615.198 711.03",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-511.873 -401.898L608.127 718.102",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-518.944 -394.828L601.056 725.172",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-526.016 -387.756L593.984 732.244",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533.086 -380.685L586.914 739.315",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-540.157 -373.614L579.843 746.386",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-547.229 -366.543L572.771 753.457",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-554.3 -359.472L565.7 760.528",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-561.37 -352.401L558.63 767.599",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-568.441 -345.33L551.559 774.67",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-575.513 -338.259L544.487 781.741",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-582.584 -331.188L537.416 788.812",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-589.654 -324.117L530.346 795.883",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-596.726 -317.046L523.274 802.954",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-603.797 -309.975L516.203 810.025",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-610.868 -302.903L509.132 817.097",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-617.939 -295.833L502.061 824.167",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-625.01 -288.761L494.99 831.239",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-632.081 -281.69L487.919 838.31",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-639.152 -274.619L480.848 845.381",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-646.224 -267.548L473.776 852.452",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-653.294 -260.477L466.706 859.523",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-660.365 -253.406L459.635 866.594",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-667.437 -246.335L452.563 873.665",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-674.508 -239.264L445.492 880.736",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-681.579 -232.193L438.421 887.807",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-688.649 -225.122L431.351 894.878",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-695.721 -218.051L424.279 901.949",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-702.792 -210.979L417.208 909.021",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-709.863 -203.909L410.137 916.091",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-716.934 -196.837L403.066 923.163",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-724.005 -189.767L395.995 930.233",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-731.076 -182.695L388.924 937.305",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-738.147 -175.625L381.853 944.375",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-745.218 -168.553L374.782 951.447",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-752.289 -161.482L367.711 958.518",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-759.36 -154.411L360.64 965.589",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-766.432 -147.34L353.568 972.66",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-773.503 -140.269L346.497 979.731",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-780.573 -133.198L339.427 986.802",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-787.645 -126.127L332.355 993.873",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-794.716 -119.056L325.284 1000.94",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-801.787 -111.985L318.213 1008.02",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-808.857 -104.914L311.143 1015.09",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-815.929 -97.8428L304.071 1022.16",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-823 -90.7715L297 1029.23",
    stroke: "#196DB6"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 741,
    r: 130,
    fill: "#F54F5E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1252,
    cy: 591,
    r: 30,
    fill: "#F54F5E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 1051,
    r: 60,
    fill: "#26B6E0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1736,
    cy: 962,
    r: 180,
    fill: "#26B6E0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1578,
    cy: 516,
    r: 60,
    fill: "#26B6E0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1282,
    cy: 1484,
    r: 180,
    fill: "#F54F5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1240_114297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1920,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.da771f4f1e3c937004e99023a754d154.svg";
export { ForwardRef as ReactComponent };